<template>
  <div class="key-value">
    <dt v-bind="labelProps" data-testid="key-value-label">
      <slot v-if="labelIcon" name="labelIcon">
        <v-icon :icon="labelIcon" size="14" />
      </slot>
      <slot name="label">{{ label }}</slot>
    </dt>
    <dd v-bind="valueProps" data-testid="key-value-value">
      <slot v-if="valueIcon" name="valueIcon">
        <v-icon :icon="valueIcon" size="14" />
      </slot>
      <slot name="value">{{ value }}</slot>
    </dd>
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      required: false,
      default: null
    },
    labelIcon: {
      type: String,
      required: false,
      default: null
    },
    value: {
      type: String,
      required: false,
      default: null
    },
    valueIcon: {
      type: String,
      required: false,
      default: null
    },
    labelProps: {
      type: Object,
      required: false,
      default: () => ({})
    },
    valueProps: {
      type: Object,
      required: false,
      default: () => ({})
    }
  }
};
</script>
<style lang="scss" scoped>
dt .v-icon {
  margin: 0 6px 2px 0;
}

dd .v-icon {
  margin: 0 6px 1px 0;
}
</style>
